import React from "react";
export const Failure = () => {
  return (
    <div>
      <div className="failure-icon"></div>
      <div className="checkout-content">
        Hello {}, Its seems that something went wrong! Please try again soon.
      </div>

      <div className="checkout-content">
        <p>
          If you further experience issues, Please clear your cache and try
          again.
        </p>
        <p>
          If you still can't login --- please get in touch with our customer
          team <a href="javascript(void);">here</a>, and we'll gladly help.
        </p>
      </div>

      <div className="checkout-content">Your error code is: HUK1234</div>
      <div className="checkout-content">
        <p>Happy Learning!!!</p>
        <p>Team yslearn</p>
      </div>
    </div>
  );
};
